import React, { useState } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import { Text, Box, Row } from "../../../comps";
import { Theme } from "../../../theme/theme-provider";

const GridItem = styled.div`
  width: 45%;
  height: 180px;
  margin-right: 5%;
  margin-bottom: 40px;
  display: block;
  box-sizing: border-box;
`;

const CardWrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
  overflow: hidden;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.8);
  }
`;

const Content = styled(Row)`
  position: absolute;
  width: 100%;
  /* height:30px; */
  bottom: 0;
  right: 0;
  /* align-items: center; */
  /* border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1}; */
  background: ${({ theme }) => theme.color.GRAY_3};
`;

const TextContainer = styled(Row)`
  height: 24px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 3px;
  font-size: 12px;
  text-align: center;
  align-items: center;
  color: ${({ theme }) => theme.color.GRAY_0};
  background: ${({ background }) => background};
`;

const Img = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.6;
`;

const Name = styled(Row)`
  position: absolute;
  top: 5px;
  left: 5px;
  align-items: baseline;
  border: 1px solid ${({ theme }) => theme.color.GRAY_0};
  border-radius: 8px 8px 8px 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5);
  background: ${({ theme }) => theme.color.GRAY_3};
  padding-right: 5px;
  padding-left: 5px;
`;

const gradients = [
  `ff0000`,
  `bf137a`,
  `0000ff`,
  `040330`,
  `1c4726`,
  `17323b`,
  `3d2215`,
  `94031e`,
  `003647`,
  `2b2a29`,
];

const Member = ({ username, idx }) => {
  return (
    <TextContainer background={`#${gradients[idx % gradients.length]}`}>
      {username}
    </TextContainer>
  );
};

export default ({ room: { id, name, members, thumbnail } }) => {
  const [redirect, setRedirect] = useState("");
  return (
    <GridItem
      className={"item"}
      key={id}
      onClick={() => {
        setRedirect(`/room/${id}`);
      }}
    >
      <div class="item-content">
        <CardWrapper>
          {redirect && <Redirect push to={redirect} />}
          <Img src={thumbnail} />
          <Name>
            <Text
              marginTop="2px"
              marginBottom="2px"
              marginLegt="2px"
              marginRight="2px"
              letterSpacing="2px"
              color={Theme.textColor.light}
              fontSize="26px"
            >{`${name}`}</Text>
            <Text
              marginBottom="2px"
              marginRight="2px"
              letterSpacing="2px"
              color={Theme.textColor.light}
              fontSize="12px"
            >{`#${id}`}</Text>
          </Name>
          <Content>
            {/* <MembersWrapper> */}
            {members &&
              members.map((member, idx) => {
                return (
                  <Member key={idx} username={member.username} idx={idx} />
                );
              })}
            {/* </MembersWrapper> */}
          </Content>
        </CardWrapper>
      </div>
    </GridItem>
  );
};
